export const BE_URL = process.env.SERVER_URL ?? 'https://be.audiomobile.xyz';

export const DeviceSize = {
    mobile: 768,
    tablet: 992,
    laptop: 1324,
    desktop: 2024,
  };
